import handleSetViewStateFailure from './handleSetViewStateFailure';
import setEditStateAction from './setEditStateAction';
import getWacInfoForSharePointFile from '../../services/getWacInfoForSharePointFile';
import {
    EditMode,
    FilePreviewUrl,
    updateFilePreviewInformation,
    getSxSViewStore,
    SharePointFileViewState,
} from 'owa-group-files-hub-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { lazySetWacPreviewState, PreviewPaneViewStateBase } from 'owa-sxsdata';
import strings from 'owa-strings/owa-mail-strings';

export default async function setViewStateForWacPreview(
    filePreviewUrl: FilePreviewUrl,
    fileViewState: SharePointFileViewState,
    optionalParameters: PreviewPaneViewStateBase
) {
    const datapoint = getSxSViewStore().datapoint;
    // Set editState to be allow edit to display the edit button
    setEditStateAction(EditMode.View, fileViewState.url, fileViewState.strategy.allowEdit);
    try {
        let wacUrl;
        if (filePreviewUrl) {
            wacUrl = filePreviewUrl.previewUrl;
        } else {
            datapoint.addCustomProperty('getWacSP', 'Started');
            wacUrl = await getWacInfoForSharePointFile(
                fileViewState.url,
                AttachmentDataProviderType.OneDrivePro,
                'PreviewInNewSxS'
            );
            datapoint.addCustomProperty('getWacSP', 'Finished');
            if (wacUrl) {
                updateFilePreviewInformation(fileViewState.id, {
                    previewUrl: wacUrl,
                    lastUpdateTime: new Date(),
                });
                datapoint.addCustomProperty('getWacSP', 'PreviewInfoUpdated');
            }
        }

        if (wacUrl) {
            // There is work in progress to support a new approach to opening the WAC for SharePoint files.
            // This code will continue to use the old approach for now.
            // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/36830
            const setWacPreviewState = await lazySetWacPreviewState.import();
            setWacPreviewState(
                getSxSViewStore().viewState,
                wacUrl,
                null, // Consumer OneDrive token
                new Date().getTime(),
                null, // Boot Script URL
                null, // Wopi Src URL
                null, // Access Token
                null, // File Name
                0, // File Size
                false, // useJsApi
                null, // File get URL
                null, // Bundle info
                optionalParameters
            );

            // We cannot end the datapoint in SxSView onLoad. Because postMessage does not work with SharePoint WAC file.
            // The E2E time for SP WAC does not include the WAC loading time.
            // More info about postMessage: http://wopi.readthedocs.io/en/latest/scenarios/postmessage.html
            datapoint.addCustomProperty('EndDatapointFrom', 'setViewStateForWacPreview');
            datapoint.end();
        } else {
            throw new Error('WAC url is not valid.');
        }
    } catch (error) {
        handleSetViewStateFailure(error, strings.errorGetWacUrl, datapoint);
    }
}
